import React from 'react';
import moment from 'moment';
import {Popup} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {convertDateToSpecificFormat} from '../common/util/date';
import {reverseShortDate, shortDate} from '../common/constants/datesFormat';
import ErrorDetailModal from './components/warrantyInvoicing/modals/ErrorDetailModal';

export const getUrl = ({initDate, endDate, typeTwc, invoice}) => {
  const parseInitDate = convertDateToSpecificFormat(initDate, reverseShortDate);
  const parseEndDate = convertDateToSpecificFormat(endDate, reverseShortDate);
  let params = `&initDate=${parseInitDate}&endDate=${parseEndDate}&typeTwc=${typeTwc}`;
  if (invoice) {
    params += `&invoice=${invoice}`;
  }
  return params;
};

export const WARRANTIES_TYPES = [
  {
    'key': 'TODOS',
    'text': 'TODOS',
    'value': 'TODOS',
  },
  {
    'key': 'VE',
    'text': 'VEHÍCULOS (VE)',
    'value': 'VE',
  },
  {
    'key': 'AC',
    'text': 'ACCESORIOS (AC)',
    'value': 'AC',
  },
  {
    'key': 'P1',
    'text': 'REPUESTOS (P1)',
    'value': 'P1',
  },
  {
    'key': 'P2',
    'text': 'REPUESTOS (P2)',
    'value': 'P2',
  },
  {
    'key': 'EX',
    'text': 'EXTENDIDAS (EX)',
    'value': 'EX',
  },
  {
    'key': 'CE',
    'text': 'CERTIFICADAS (CE)',
    'value': 'CE',
  },
];

export const columnsReportTable = (reportType) => {
  let columns = [
    {
      'Header': 'INFORMACIÓN GARANTÍA',
      'disableFilters': true,
      'columns': [
        {
          'Header': 'FECHA',
          'accessor': 'dateTwc',
          'Cell': ({row}) => {
            const {dateTwc} = row.original;
            return moment(dateTwc).format(shortDate);
          },
        },
        {
          'Header': 'NÚMERO TWC DEALER',
          'accessor': 'numTwcDealer',
        },
        {
          'Header': 'DEALER',
          'accessor': 'dealer',
        },
        {
          'Header': 'CUENTA DE COBRO',
          'accessor': 'twcAccountDefinitive',
        },
        {
          'Header': 'NÚMERO GARANTÍA',
          'accessor': 'numTwc',
        },
        {
          'Header': 'CAMPAÑA',
          'accessor': 'campaingName',
          'Cell': ({row}) => {
            const {campaingName, sscCode} = row.original;
            if (!sscCode && !campaingName) {
              return '';
            }
            return `${sscCode} ${campaingName}`;
          },
        },
        {
          'Header': 'CÓDIGO TAREA',
          'accessor': 'principalTask',
        },
        {
          'Header': 'KATASHIKI',
          'accessor': 'model',
        },
        {
          'Header': 'MODELO',
          'accessor': 'modelDescription',
        },
        {
          'Header': 'VEHÍCULO',
          'accessor': 'chassis',
        },
        {
          'Header': 'ESTADO TWC',
          'accessor': 'twcStatusDescription',
        },
      ],
    },
    {
      'Header': 'RECIBIDO POR TDE',
      'disableFilters': true,
      'columns': [
        {
          'Header': 'TRABAJOS',
          'accessor': 'totalReceivedJobs',
          'Cell': ({row}) => {
            const {totalReceivedJobs} = row.original;
            return totalReceivedJobs.toFixed(2);
          },
        },
        {
          'Header': 'PARTES',
          'accessor': 'totalReceivedParts',
          'Cell': ({row}) => {
            const {totalReceivedParts} = row.original;
            return totalReceivedParts.toFixed(2);
          },
        },
        {
          'Header': 'SUBCONT.',
          'accessor': 'totalReceivedSubcont',
          'Cell': ({row}) => {
            const {totalReceivedSubcont} = row.original;
            return totalReceivedSubcont.toFixed(2);
          },
        },
        {
          'Header': 'TOTAL',
          'accessor': 'totalReceived',
          'Cell': ({row}) => {
            const {totalReceived} = row.original;
            return totalReceived.toFixed(2);
          },
        },
      ],
    },
    {
      'Header': 'APROBADO POR TDE',
      'disableFilters': true,
      'columns': [
        {
          'Header': 'TRABAJOS',
          'accessor': 'totalApprovedJobs',
          'Cell': ({row}) => {
            const {totalApprovedJobs} = row.original;
            return totalApprovedJobs.toFixed(2);
          },
        },
        {
          'Header': 'PARTES',
          'accessor': 'totalApprovedParts',
          'Cell': ({row}) => {
            const {totalApprovedParts} = row.original;
            return totalApprovedParts.toFixed(2);
          },
        },
        {
          'Header': 'SUBCONT.',
          'accessor': 'totalApprovedSubcont',
          'Cell': ({row}) => {
            const {totalApprovedSubcont} = row.original;
            return totalApprovedSubcont.toFixed(2);
          },
        },
        {
          'Header': 'TOTAL',
          'accessor': 'totalApproved',
          'Cell': ({row}) => {
            const {totalApproved} = row.original;
            return totalApproved.toFixed(2);
          },
        },
      ],
    },
  ];

  if (reportType === 'TWC' && columns.length < 4) {
    const providerApproved = [
      {
        'Header': 'APROBADO POR FABRICANTE',
        'disableFilters': true,
        'columns': [
          {
            'Header': 'TRABAJOS',
            'accessor': 'totalApprovedProviderJobs',
            'Cell': ({row}) => {
              const {totalApprovedProviderJobs} = row.original;
              return totalApprovedProviderJobs.toFixed(2);
            },
          },
          {
            'Header': 'PARTES',
            'accessor': 'totalApprovedProviderParts',
            'Cell': ({row}) => {
              const {totalApprovedProviderParts} = row.original;
              return totalApprovedProviderParts.toFixed(2);
            },
          },
          {
            'Header': 'SUBCONT.',
            'accessor': 'totalApprovedProviderSubcont',
            'Cell': ({row}) => {
              const {totalApprovedProviderSubcont} = row.original;
              return totalApprovedProviderSubcont.toFixed(2);
            },
          },
          {
            'Header': 'TOTAL',
            'accessor': 'totalApprovedProvider',
            'Cell': ({row}) => {
              const {totalApprovedProvider} = row.original;
              return totalApprovedProvider.toFixed(2);
            },
          },
        ],
      },
      {
        'Header': '',
        'id': 'partCost',
        'disableFilters': true,
        'columns': [
          {
            'Header': 'COSTO REPUESTO TDE',
            'accessor': 'partCostTDE',
            'Cell': ({row}) => {
              const {partCostTDE} = row.original;
              return partCostTDE.toFixed(2);
            },
          },
        ],
      },
    ];

    columns = columns.concat(providerApproved);
  }

  return columns;
};

export const columnsInvoiceTable = [
  {
    'Header': 'NUM TWC DEALER',
    'accessor': 'numTwcDealer',
  },
  {
    'Header': 'ORDEN',
    'accessor': 'order',
  },
  {
    'Header': 'MANO DE OBRA',
    'accessor': 'jobsDiff',
  },
  {
    'Header': 'PARTES',
    'accessor': 'partsDiff',
  },
  {
    'Header': 'SUBCONTRATOS',
    'accessor': 'subcontDiff',
  },
  {
    'Header': 'TOTAL TWC',
    'accessor': 'totalTwc',
  },
  {
    'id': 'actions',
    'Header': 'ACCIONES',
    'Cell': ({row}) => {
      const {code, numTwcDealer, dealerId, totalsDetail, invalid, updated} = row.original;

      if (code && numTwcDealer && dealerId) {
        return (
          <>
            <Popup
              trigger={
                <Link
                  to={`/editar-garantias-admin/${code}/${numTwcDealer}/${dealerId}`}
                  target='_blank'
                >
                  <span className='link edition'>
                    <i className='material-icons'>edit</i>
                  </span>
                </Link>
              }
              content={`Editar Garantía ${code}`}
              position='top center'
              inverted
            />
            <ErrorDetailModal
              totalsDetail={totalsDetail}
              updated={updated}
              code={code}
              invalid={invalid}
            />
          </>
        );
      }
      return (
        <ErrorDetailModal
          totalsDetail={totalsDetail}
          updated={updated}
          code={code}
          invalid={invalid}
        />
      );
    },
  },
];
